<template>
    <div>
        <div class="panel panel-default">
            <div class="panel-heading">Scope Editor</div>

            <div class="panel-body">
                Hello
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['scope_id'],
        data() {
            return {
                temp:null
            }
        },
        methods: {
            temp() {
                console.log("does this work?")
            }
        }
    }

</script>